/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackCommentCountResponse
 */
export interface TrackCommentCountResponse {
    /**
     * 
     * @type {number}
     * @memberof TrackCommentCountResponse
     */
    data?: number;
}

/**
 * Check if a given object implements the TrackCommentCountResponse interface.
 */
export function instanceOfTrackCommentCountResponse(value: object): value is TrackCommentCountResponse {
    let isInstance = true;

    return isInstance;
}

export function TrackCommentCountResponseFromJSON(json: any): TrackCommentCountResponse {
    return TrackCommentCountResponseFromJSONTyped(json, false);
}

export function TrackCommentCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackCommentCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function TrackCommentCountResponseToJSON(value?: TrackCommentCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

